import React, { useEffect, useState } from "react"
import { Col, Card, CardBody, Row } from "reactstrap"
import { DashboardReportTypes } from 'constants/layout'
import { get } from 'helpers/api_helper'

const TopProducts = () => {
    const [type, setType] = useState(DashboardReportTypes[0])
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(true)
  
    useEffect(async() => {
      setLoading(true)
      setData(null)
      try {
        const res = await get(`api/org/topproducts/${type.value}`)
        if (res && res.status == 200) {
          setData(res.response)
        }
      } catch (err) {
        console.error("TopProducts error:", err)
      } finally {
        setLoading(false)
      }
    }, [type])
    
    return (
        <Row>
            <Col md="12">
                <Card className="shadow-sm border-0">
                    <CardBody>
                        <Row className="mb-3 align-items-center">
                            <Col>
                                <h4 className="card-title mb-0">{type.title} Top Products</h4>
                            </Col>
                            <Col md="3">
                                <select onChange={(e) => setType(JSON.parse(e.target.value))} className="form-select form-control" name="fmytd">
                                    {
                                        DashboardReportTypes?.map((v,i) => <option value={JSON.stringify(v)} key={`TPD_${i}${v.value}`}>{v.title}</option>)
                                    }
                                </select>
                            </Col>
                        </Row>
                        <div className="table-responsive">
                            <table className="table table-hover align-middle mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>#</th>
                                        <th>Product Code</th>
                                        <th>Product</th>
                                        <th>Product type</th>
                                        <th>Product Category</th>
                                        <th>Total Units</th>
                                        <th>Total Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading || !data ? (
                                        Array.from({ length: 5 }).map((_, idx) => (
                                            <tr key={`skel_prod_${idx}`}>
                                                <td><div className="shimmer-box shimmer-text" style={{ width: '20px', height: '14px', marginBottom: 0 }} /></td>
                                                <td><div className="shimmer-box shimmer-text" style={{ width: '60px', height: '14px', marginBottom: 0 }} /></td>
                                                <td><div className="shimmer-box shimmer-text" style={{ width: '140px', height: '14px', marginBottom: 0 }} /></td>
                                                <td><div className="shimmer-box shimmer-text" style={{ width: '90px', height: '14px', marginBottom: 0 }} /></td>
                                                <td><div className="shimmer-box shimmer-text" style={{ width: '100px', height: '14px', marginBottom: 0 }} /></td>
                                                <td><div className="shimmer-box shimmer-text" style={{ width: '50px', height: '14px', marginBottom: 0 }} /></td>
                                                <td><div className="shimmer-box shimmer-text" style={{ width: '70px', height: '14px', marginBottom: 0 }} /></td>
                                            </tr>
                                        ))
                                    ) : data.length === 0 ? (
                                        <tr>
                                            <td colSpan="7" className="text-center py-4 text-muted">
                                                No top products found for this period.
                                            </td>
                                        </tr>
                                    ) : (
                                        data.map((v, i) => (
                                            <tr key={i} className="fade-in-content">
                                                <td>{i + 1}</td>
                                                <td><span className="badge bg-light text-dark font-size-12">{v.product_id}</span></td>
                                                <td className="fw-medium text-dark">{v.title}</td>
                                                <td>{v.type || '-'}</td>
                                                <td>{v.category || '-'}</td>
                                                <td><span className="fw-semibold">{v.units}</span></td>
                                                <td><span className="text-success fw-bold">₹{Number(v.total || 0).toLocaleString()}</span></td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    )
}

export default TopProducts